import React from 'react'
import { listAnalysesByTimelineRootId, type AnalysisItem } from '../services/analysisService'

type UseTimelineAnalysesResult = {
  items: AnalysisItem[]
  loading: boolean
  error: string | null
}

export function useTimelineAnalyses(
  timelineRootId: number | null,
  enabled: boolean,
): UseTimelineAnalysesResult {
  const [items, setItems] = React.useState<AnalysisItem[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!enabled || timelineRootId == null) {
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listAnalysesByTimelineRootId({ timelineRootId })
      .then((next) => {
        if (!active) return
        setItems(next || [])
      })
      .catch((e: any) => {
        if (!active) return
        setItems([])
        setError(e?.message || 'Falha ao carregar historico de analises')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, timelineRootId])

  return { items, loading, error }
}
